
import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';


export default function CommunityDetailsModal({ Close
    , selectCommunity, selectedForumGroups, onInnerBasicFormChange }: any) {

    const InfoItem = ({ label, value }: { label: string; value: any }) => (
        <div className="p-4 bg-gradient-to-r from-indigo-100 to-purple-100 border border-indigo-300 rounded-xl shadow-md hover:shadow-lg transition">
            <p className="text-sm font-bold text-indigo-700">{label}</p>
            <p className="mt-1 text-base text-gray-900">{value ?? '-'}</p>
        </div>
    );
    return (
        <>
            <AccordionContainer
                expandedPanel="userInfo"
                headerTitle={
                    <span className="text-xl text-black rounded-full shadow">
                        Community Basic Info
                    </span>
                }
                child={
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                        <InfoItem label="Name" value={selectCommunity?.Name} />

                        <InfoItem label="Region" value={selectCommunity?.Region} />
                        <InfoItem
                            label="Training Available"
                            value={selectCommunity?.IsTrainingAvailable ? 'Yes' : 'No'}
                        />
                        <InfoItem label="Description" value={selectCommunity?.Description} />
                        <InfoItem label="Events Count" value={selectCommunity?.EventsCount} />
                        <InfoItem label="Training Available" value={selectCommunity?.IsTrainingAvailable ? 'Yes' : 'No'} />
                        <InfoItem label="Members Count" value={selectCommunity?.MembersCount} />

                    </div>
                }
            />
        </>
    );
}